import React, {useMemo, useState} from "react";
import {PageLoader} from "../../core/commons/page-loader/page-loader";
import {Button, Space, Table} from "antd";
import {columnsFactory} from "./catalog.oem-search-result.columns";
import {useTranslation} from "react-i18next";
import {CatalogArticleStock, CatalogByOEMItem} from "../../../models/articles/catalog/search";
import {ResultExportModal} from "./result-export/result-export.modal";
import {Amount} from "../../../models/amount/amount";

interface CatalogOEMSearchResultProps {
    loading: boolean;
    items: CatalogByOEMItem[];
    file: File;
}

export interface TableRow {
    found: boolean;
    requestedName: string;
    id: number;
    analogueName?: string;
    name?: string;
    description?: string;
    amount?: Amount;
    stock?: CatalogArticleStock[];
    inWishList: boolean;
    inCartQty: number;
    multiple: number;
    replacement?: "full" | "partial"
}

const buildTableRows = (result: CatalogByOEMItem[]): TableRow[]  => {
    const rows: TableRow[] = [];

    result.forEach((item, index) => {
        if (item.found) {
            item.result.forEach((resultItem, itemIndex) => {
                rows.push({
                    found: true,
                    requestedName: itemIndex === 0 ? item.requestedName : '',
                    ...resultItem
                })
            })
        } else {
            rows.push({
                id: -index,
                found: false,
                requestedName: item.requestedName,
                inCartQty: 0,
                inWishList: false,
                multiple: 0
            })
        }
    })

    return rows;
}

export const CatalogOEMSearchResult: React.FC<CatalogOEMSearchResultProps> = ({loading, items, file}) => {

    const {t} = useTranslation("translation", {useSuspense: false});
    const [downloadModalShown, setDownloadModalShown] = useState<boolean>(false);

    const warehouses = useMemo(() => {
        const result = new Set<string>();
        items.forEach(item => {
            if (item.found) {
                item.result.forEach(resultItem => resultItem.stock.forEach(stockItem => result.add(stockItem.warehouse)))
            }
        })
        return result;
    }, [items])

    const dataSource = useMemo(() => buildTableRows(items), [items])

    const columns = useMemo(() => columnsFactory(t, warehouses), [warehouses])

    if (loading) {
        return <Space direction={"vertical"} style={{marginTop: "3px"}}>
            <PageLoader />
        </Space>
    }

    if (items.length === 0) {
        return <></>;
    }

    return (
        <>
            <Space direction={"vertical"} style={{marginTop: "3px"}}>
                <Space direction={"horizontal"} style={{marginTop: "10px", justifyContent: "flex-end", display: "flex"}}>
                    <Button
                        type={"primary"}
                        loading={loading}
                        onClick={() => setDownloadModalShown(true)}
                        style={{backgroundColor: "#f93822", borderColor: "#f93822"}}
                    >
                        {t("DOWNLOAD.DO_DOWNLOAD")}
                    </Button>
                </Space>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    rowKey={"id"}
                />
            </Space>
            {downloadModalShown ? (
                <ResultExportModal
                    file={file}
                    onClose={() => setDownloadModalShown(false)}
                />
            ) : null}
        </>
    )
}